import { Button, Container } from '@sloyd/ui';
import { Actions, Explain, H1, Image, Tagline, Wrapper } from './ContentOffer.style';

export type ContentOfferProps = {
  onPlanSelect: (planId: string) => void;
};

export function ContentOffer(props: ContentOfferProps) {
  return (
    <Wrapper className='ContentOffer-wrapper' data-testid='ContentOffer-wrapper'>
      <Container size='sm'>
        <Tagline className='animate__animated animate__fadeInDown animate__faster'>
          Welcome Spring with a Wild Deal! 🎉
        </Tagline>

        <H1 className='animate__animated animate__fadeInUp animate__faster'>
          Easter Special - 67% Off!
        </H1>

        <Explain className='animate__animated animate__fadeInUp animate__faster'>
          Get <strong>two full months</strong> for just <strong>$4.99</strong> each. Unleash your
          imagination and save big!
        </Explain>

        <Image className='animate__animated animate__zoomIn animate__faster' />

        <Actions className='animate__animated animate__fadeInUp animate__faster'>
          <Button
            size='xl'
            color='pink'
            onClick={() => props.onPlanSelect('MONTH_POPULAR')}
            variant='gradient'
            gradient={{ from: 'rgb(251,0,157)', to: 'rgb(251,0,84)' }}
          >
            Get your 67% discount
          </Button>
        </Actions>
      </Container>
    </Wrapper>
  );
}

export default ContentOffer;
